import { IconWrapper } from '../runtime';
export default IconWrapper('vote', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4 7.74976H3.25C2.42157 7.74976 1.75 8.42133 1.75 9.24976V12.7498C1.75 13.5782 2.42157 14.2498 3.25 14.2498H12.75C13.5784 14.2498 14.25 13.5782 14.25 12.7498V9.24976C14.25 8.42133 13.5784 7.74976 12.75 7.74976H12M6.5 5.99976L7.28787 6.78762C7.40503 6.90478 7.59497 6.90478 7.71213 6.78762L9.5 4.99976M11.75 10.7498V3.24976C11.75 2.42133 11.0784 1.74976 10.25 1.74976H5.75C4.92157 1.74976 4.25 2.42133 4.25 3.24976V10.7498H11.75Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});